import { PayloadAction } from '@reduxjs/toolkit';
import { PlanboardState } from '@reducers/v2/planboard/types';

export const setPlanboardSearchValueAction = (state: PlanboardState, action: PayloadAction<string | undefined>) => {
  state.searchValue = action.payload;
};
